<template>
    <iframe class="responsive-iframe" :src="homeDashboard" frameborder="0" style="border:0" allowfullscreen></iframe>
</template>

<script>
import Vue from "vue";
import { Auth, oAuth } from "../../../classes/Auth";
export default Vue.extend({
  name: "Dashboard10",
  props: {
    source: String,
  },
  data: () => ({
      homeDashboard: '',
      auth: new Auth()
  }),
  mounted(){
    if(this.auth.getProject().name == 'DAVIVIENDA'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/a9482366-f847-49fc-9947-6cd3c28e8d95/page/8VcaB"
    }
    if(this.auth.getProject().name == 'DOLLARCITY'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/467c2cef-19aa-4dc1-894d-0b10d9d4fd72/page/8VcaB"
    }
    if(this.auth.getProject().name == 'EAAV ESP'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/a5e9f4c0-9188-410f-83e7-6d31cbb1b98c/page/8VcaB"
    }
    if(this.auth.getProject().name == 'MAKRO'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/c601dd91-132c-4add-9e7c-0f8b47bae868/page/P8g2B"
    }
    if(this.auth.getProject().name == 'DEMO'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/a1ba89e8-370f-4109-a96b-598dbcf77b91/page/P8g2B"
    }
    if(this.auth.getProject().name == 'DAVIVIENDA II'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/ee921382-bfc5-492d-af19-02bb80215b2d/page/1M"
    }
  }
});
</script>

<style>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>

